import {Injectable, Injector} from '@angular/core';
import {ServiceInitializer, ShellService} from '@edifecs/fp-ui-shell';
import {EnvService} from '@app/core/services/EnvService';
import {SubtenantService} from '@app/core/services/SubtenantService';
import {AppConfigService} from '@app/core/services/AppConfigService';
import {SubtenantErrorComponent} from '@app/core/components/SubtenantErrorComponent';

/**
 * Service to help the shell UI initialize app services on start.
 */
@Injectable({providedIn: 'root'})
export class InitializerService implements ServiceInitializer {

    /**
     * Constructor
     * @param injector App injector
     * @param shellSvc Shell service
     */
    constructor(private readonly injector: Injector,
                private readonly shellSvc: ShellService) {
    }

    /**
     * @internal
     * @inheritDoc
     */
    async initialize(): Promise<void> {
        // environment s to be initialized first
        await this.injector.get(EnvService).init();

        // app config to be fetched next
        await this.injector.get(AppConfigService).init();

        // subtenant service to be setup after
        const subtenantService = this.injector.get(SubtenantService);
        subtenantService.setSubtenantRequiredHandler(err => SubtenantErrorComponent.show(err, this.shellSvc));
        await subtenantService.init();
    }
}
